import { useEffect, useState } from 'react'
import { supabase } from '../supabaseClient'
import { useAuth } from '../context/AuthContext'
import { useNavigate } from 'react-router-dom'
import Navbar from '../components/Navbar'

export default function ProgramTemplates() {
  const { profile } = useAuth()
  const navigate = useNavigate()
  const [templates, setTemplates] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => { fetchTemplates() }, [])

  async function fetchTemplates() {
    const { data } = await supabase
      .from('diagnosis_templates')
      .select('*, diagnosis_template_exercises(*, exercises(*))')
      .eq('clinic_id', profile.clinic_id)
      .order('created_at')
    setTemplates(data || [])
    setLoading(false)
  }

  async function handleDelete(id) {
    if (!confirm('Delete this program template?')) return
    await supabase.from('diagnosis_templates').delete().eq('id', id)
    setTemplates(prev => prev.filter(t => t.id !== id))
  }

  return (
    <>
      <Navbar />
      <div className="page">
        <span onClick={() => navigate('/clinician')} className="back-link" style={{ cursor: 'pointer' }}>← Dashboard</span>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '2rem' }}>
          <div>
            <h1>Program templates</h1>
            <p>Pre-built exercise programs by program</p>
          </div>
          <button onClick={() => navigate('/clinician/diagnoses/new')}>+ New template</button>
        </div>

        {loading && <p>Loading...</p>}

        {!loading && templates.length === 0 && (
          <div className="empty-state">
            <div className="empty-state-icon">🩻</div>
            <h2 style={{ marginBottom: 8 }}>No templates yet</h2>
            <p style={{ marginBottom: '1.5rem' }}>Create your first program template</p>
            <button onClick={() => navigate('/clinician/diagnoses/new')}>+ New template</button>
          </div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {templates.map(template => (
            <div key={template.id} className="card">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                <div>
                  <p style={{ fontWeight: 600, color: 'var(--text-primary)', fontSize: 15, margin: '0 0 4px' }}>
                    {template.name}
                    {template.is_default && (
                      <span className="badge" style={{ marginLeft: 8, fontSize: 11 }}>Default</span>
                    )}
                  </p>
                  {template.description && <p style={{ fontSize: 13, margin: 0 }}>{template.description}</p>}
                </div>
                <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                  <button className="secondary" onClick={() => navigate('/clinician/diagnoses/' + template.id + '/edit')} style={{ fontSize: 12, padding: '6px 12px' }}>Edit</button>
                  <button className="danger" onClick={() => handleDelete(template.id)} style={{ fontSize: 12 }}>Delete</button>
                </div>
              </div>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {template.diagnosis_template_exercises?.map(te => (
                  <span key={te.id} className="badge" style={{ fontSize: 11 }}>{te.exercises?.title}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
